import { render, staticRenderFns } from "./TotalRecaudacionComponent.vue?vue&type=template&id=55cb7cbd"
import script from "./TotalRecaudacionComponent.vue?vue&type=script&lang=js"
export * from "./TotalRecaudacionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports